// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1aM1M","col":"styles_col__3aI9r"};